import { useEffect } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import { useDispatch, useSelector } from "react-redux";

import { selectIsInitialFiltersReady } from "app/pages/sales-intelligence/modules/advanced-search-filtering/store/selectors";
import { useIsLeadsCriticalDataLoading } from "app/pages/sales-intelligence/modules/leads-search/hooks/useIsLeadsCriticalDataLoading";
import type { SavedSearchRoutingParams } from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/types";

import { useLeadGeneratorAgentThread } from "../queries/useLeadGeneratorAgentThread";
import { setInitialFilterSetMessage } from "../store";

type HookValue = {
    threadId: string;
    isThreadCreationPending: boolean;
};

export const useLeadGeneratorChatInit = (): HookValue => {
    const dispatch = useDispatch();

    const {
        params: { savedSearchId },
    } = useCurrentStateAndParams<Partial<SavedSearchRoutingParams>>();

    const { data: threadId = "", isFetching: isThreadCreationPending } = useLeadGeneratorAgentThread(savedSearchId);
    const isLeadsCriticalDataLoading = useIsLeadsCriticalDataLoading();

    const isInitialFiltersReady = useSelector(selectIsInitialFiltersReady);

    const arePostMessagesEnabled = [
        !isThreadCreationPending,
        !!threadId,
        !isLeadsCriticalDataLoading,
        isInitialFiltersReady,
    ].every(Boolean);

    useEffect(() => {
        if (arePostMessagesEnabled) {
            void dispatch(setInitialFilterSetMessage());
        }
    }, [arePostMessagesEnabled, dispatch]);

    return {
        threadId,
        isThreadCreationPending,
    };
};
